export const mobile_query = '(max-width: 768px)';
export const tablet_query = '(min-width: 769px)';
export const touch_query = '(max-width: 959px)';
export const desktop_query = '(min-width: 960px)';